import "./ResultsText.css";

const ResultsText = ({ count }: { count: number }) => {
  return (
    <p id="text">
      <span id="count">{count}</span> results
    </p>
  );
};

export default ResultsText;
